import getLang from './default-lang'

const numberFormatByLocale: Record<string, Intl.NumberFormat> = {}

const printPercentage = (
  value: number | bigint,
  locale: string = getLang(),
  maximumFractionDigits?: number
): string => {
  maximumFractionDigits = maximumFractionDigits ?? 2
  const key = locale + '_' + maximumFractionDigits
  if (!numberFormatByLocale[key]) {
    numberFormatByLocale[key] = new Intl.NumberFormat(locale, {
      style: 'percent',
      maximumFractionDigits,
    })
  }
  // arredonda x.01 para x e x.99 para x+1
  if (value && typeof value == 'number' && maximumFractionDigits === 2) {
    const cents = Math.round(value * 100000) % 1000
    if (cents <= 15 || cents >= 985) {
      value = Math.round(value * 100) / 100
    }
  }
  return numberFormatByLocale[key].format(value)
}

export default printPercentage
